import React from 'react';
import { AlertCircle, CheckCircle2, XCircle } from 'lucide-react';
export function StorySection() {
  return <section className="bg-white py-20 px-4" data-id="element-331">
      <div className="max-w-3xl mx-auto" data-id="element-332">
        <div className="text-center mb-12" data-id="element-333">
          <span className="text-neon font-bold text-sm tracking-widest uppercase bg-black px-4 py-1 rounded-full" data-id="element-334">
            — ANTES DE QUE SIGAS LEYENDO —
          </span>
        </div>

        <h2 className="text-3xl md:text-5xl font-extrabold text-black text-center leading-tight mb-12 font-montserrat" data-id="element-335">
          "¿Cuánto Tiempo Más Vas a Seguir Mirando el Saldo del Banco el Día 20
          y Cerrar la App Rápido?"
        </h2>

        <div className="text-lg text-gray-800 space-y-6 mb-16" data-id="element-336">
          <p data-id="element-337">Permíteme ser directo contigo.</p>
          <p data-id="element-338">
            En España, el salario mediano neto es de{' '}
            <strong className="text-black text-xl" data-id="element-339">1.450€ al mes.</strong>
          </p>
          <p data-id="element-340">
            Cuando lo pones frente a los gastos reales de vivir en cualquier
            ciudad española, el margen que queda es casi inexistente.
          </p>
          <p className="font-medium" data-id="element-341">
            Alquiler. Comida. Transporte. Suministros. Móvil.
          </p>
          <p data-id="element-342">Y al final del mes... nada. O peor: números rojos.</p>
          <p data-id="element-343">No es que seas mal gestor del dinero.</p>
          <p data-id="element-344">No es que gastes demasiado en caprichos.</p>
          <p className="font-bold text-xl text-black" data-id="element-345">
            Es que el sistema está roto para la mayoría de personas.
          </p>
          <p data-id="element-346">Y los consejos de siempre no funcionan:</p>
        </div>

        <div className="bg-gray-900 rounded-2xl border-2 border-neon p-6 md:p-10 mb-16 shadow-neon-lg" data-id="element-347">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-white" data-id="element-348">
            <div className="font-bold text-xl text-center md:text-left border-b border-gray-700 pb-4 mb-2 md:border-none md:pb-0 md:mb-0" data-id="element-349">
              <span className="text-red-500 mr-2" data-id="element-350">❌</span> Lo que te Han Dicho
            </div>
            <div className="font-bold text-xl text-center md:text-left border-b border-gray-700 pb-4 mb-4 md:border-none md:pb-0 md:mb-0" data-id="element-351">
              <span className="text-neon mr-2" data-id="element-352">✅</span> La Realidad
            </div>

            <div className="flex items-start gap-3 text-gray-400" data-id="element-353">
              <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-1" data-id="element-354" />
              <span data-id="element-355">"Ahorra más, gasta menos"</span>
            </div>
            <div className="flex items-start gap-3" data-id="element-356">
              <CheckCircle2 className="w-6 h-6 text-neon shrink-0 mt-1" data-id="element-357" />
              <span data-id="element-358">Hay un límite matemático en cuánto puedes recortar</span>
            </div>

            <div className="flex items-start gap-3 text-gray-400" data-id="element-359">
              <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-1" data-id="element-360" />
              <span data-id="element-361">"Busca un segundo trabajo"</span>
            </div>
            <div className="flex items-start gap-3" data-id="element-362">
              <CheckCircle2 className="w-6 h-6 text-neon shrink-0 mt-1" data-id="element-363" />
              <span data-id="element-364">Contratos parciales de 600€ con horarios imposibles</span>
            </div>

            <div className="flex items-start gap-3 text-gray-400" data-id="element-365">
              <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-1" data-id="element-366" />
              <span data-id="element-367">"Haz dropshipping"</span>
            </div>
            <div className="flex items-start gap-3" data-id="element-368">
              <CheckCircle2 className="w-6 h-6 text-neon shrink-0 mt-1" data-id="element-369" />
              <span data-id="element-370">Márgenes del 5%, inversión en ads, mercado saturado</span>
            </div>

            <div className="flex items-start gap-3 text-gray-400" data-id="element-371">
              <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-1" data-id="element-372" />
              <span data-id="element-373">"Invierte en cripto"</span>
            </div>
            <div className="flex items-start gap-3" data-id="element-374">
              <CheckCircle2 className="w-6 h-6 text-neon shrink-0 mt-1" data-id="element-375" />
              <span data-id="element-376">Alto riesgo, pérdidas probables al inicio</span>
            </div>

            <div className="flex items-start gap-3 text-gray-400" data-id="element-377">
              <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-1" data-id="element-378" />
              <span data-id="element-379">"Vende en Wallapop"</span>
            </div>
            <div className="flex items-start gap-3" data-id="element-380">
              <CheckCircle2 className="w-6 h-6 text-neon shrink-0 mt-1" data-id="element-381" />
              <span data-id="element-382">Ingreso puntual, no recurrente, se agota</span>
            </div>
          </div>
        </div>

        <div className="text-lg text-gray-800 space-y-6 mb-16 text-center" data-id="element-383">
          <p data-id="element-384">Todas estas opciones tienen un problema en común:</p>
          <p className="font-bold text-xl text-black" data-id="element-385">
            O requieren inversión que no tienes. O requieren tiempo que no
            tienes. O ambas cosas.
          </p>
          <p data-id="element-386">
            Hasta que descubrí algo que cambió completamente mi forma de ver el
            problema.
          </p>
        </div>

        <div className="bg-black border-4 border-neon rounded-2xl p-8 md:p-12 shadow-neon-lg relative" data-id="element-387">
          <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-neon text-black font-black px-6 py-2 rounded-full flex items-center gap-2" data-id="element-388">
            <AlertCircle className="w-5 h-5" data-id="element-389" />
            LO QUE NADIE TE ESTÁ CONTANDO
          </div>

          <div className="text-white text-lg md:text-xl leading-relaxed space-y-6 mt-6 text-center" data-id="element-390">
            <p data-id="element-391">
              Las marcas españolas están migrando masivamente su publicidad de
              la televisión a TikTok e Instagram.
            </p>
            <p data-id="element-392">
              Y para competir en esas plataformas, necesitan un tipo de
              contenido muy específico:
            </p>
            <p className="text-neon font-bold text-2xl" data-id="element-393">
              Videos que parezcan grabados por una persona real.
            </p>
            <p data-id="element-394">Auténticos. Cotidianos. Sin producción de estudio.</p>
            <p className="font-bold" data-id="element-395">Ese contenido se llama UGC.</p>
            <p className="text-2xl font-black border-t border-gray-800 pt-6 mt-6" data-id="element-396">
              Y tú puedes producirlo con el móvil que ya tienes.
            </p>
          </div>
        </div>
      </div>
    </section>;
}